"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2817],{

/***/ 32817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jj": function() { return /* binding */ useDefaultsFromURLSearch; },
  "SM": function() { return /* binding */ useDerivedSwapInfo; },
  "aT": function() { return /* binding */ useLPApr; },
  "yF": function() { return /* binding */ useSingleTokenSwapInfo; },
  "dU": function() { return /* binding */ useSwapState; }
});

// UNUSED EXPORTS: queryParametersToSwapState, useFetchPairPrices

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 15 modules
var swap_sdk_src = __webpack_require__(10427);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 7 modules
var tokens_src = __webpack_require__(22366);
// EXTERNAL MODULE: ./packages/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(68492);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(94293);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/config/abi/taxDetector.json
var taxDetector = __webpack_require__(66766);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(56797);
;// CONCATENATED MODULE: ./src/hooks/useFeeOnTransferDetector.ts









function useFeeOnTransferDetectorContract(chainId) {
    var contract = (0,useContract/* useContract */.cq)((0,addressHelpers/* getFeeOnTransferAddress */._)(chainId), taxDetector, true);
    return contract;
}
var AMOUNT_TO_BORROW = 1000000000 // smallest amount that has full precision over bps
;
var FEE_CACHE = {};
function getSwapTaxes(fotDetector, inputTokenAddress, outputTokenAddress, chainId) {
    return _getSwapTaxes.apply(this, arguments);
}
function _getSwapTaxes() {
    _getSwapTaxes = (0,src_async_to_generator/* default */.Z)(function(fotDetector, inputTokenAddress, outputTokenAddress, chainId) {
        var ref, ref1, addresses, data, e, ref2, inputTax, ref3, outputTax;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    addresses = [];
                    if (inputTokenAddress && FEE_CACHE[inputTokenAddress] === undefined) {
                        addresses.push(inputTokenAddress);
                    }
                    if (outputTokenAddress && FEE_CACHE[outputTokenAddress] === undefined) {
                        addresses.push(outputTokenAddress);
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!addresses.length) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fotDetector.callStatic.batchValidate(swap_sdk_src/* FACTORY_ADDRESS_MAP */.sL[chainId], addresses, swap_sdk_src/* WNATIVE */.FX[chainId].address, AMOUNT_TO_BORROW)
                    ];
                case 2:
                    data = _state.sent();
                    addresses.forEach(function(address, index) {
                        var _index = data[index], sellFeeBps = _index.sellFeeBps, buyFeeBps = _index.buyFeeBps;
                        var sellTax = new swap_sdk_src/* Percent */.gG(sellFeeBps.toNumber(), exchange/* BIPS_BASE */.PM);
                        var buyTax = new swap_sdk_src/* Percent */.gG(buyFeeBps.toNumber(), exchange/* BIPS_BASE */.PM);
                        FEE_CACHE[address] = {
                            sellTax: sellTax,
                            buyTax: buyTax
                        };
                    });
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    console.error("useSwapTaxes", "getSwapTaxes", "Failed to get swap taxes for token(s):", addresses, e);
                    return [
                        3,
                        5
                    ];
                case 5:
                    inputTax = (ref2 = inputTokenAddress ? (ref = FEE_CACHE[inputTokenAddress]) === null || ref === void 0 ? void 0 : ref.sellTax : exchange/* ZERO_PERCENT */.fI) !== null && ref2 !== void 0 ? ref2 : exchange/* ZERO_PERCENT */.fI;
                    outputTax = (ref3 = outputTokenAddress ? (ref1 = FEE_CACHE[outputTokenAddress]) === null || ref1 === void 0 ? void 0 : ref1.buyTax : exchange/* ZERO_PERCENT */.fI) !== null && ref3 !== void 0 ? ref3 : exchange/* ZERO_PERCENT */.fI;
                    return [
                        2,
                        {
                            inputTax: inputTax,
                            outputTax: outputTax
                        }
                    ];
            }
        });
    });
    return _getSwapTaxes.apply(this, arguments);
}
// Use the buyFeeBps/sellFeeBps fields from Token GQL query where possible instead of this hook
function useSwapTaxes(inputTokenAddress, outputTokenAddress, tokenChainId) {
    var ref = (0,useActiveChainId/* useActiveChainId */.gi)(), currChainId = ref.chainId;
    var chainId = tokenChainId !== null && tokenChainId !== void 0 ? tokenChainId : currChainId;
    var fotDetector = useFeeOnTransferDetectorContract(chainId);
    var ref1 = (0,react.useState)({
        inputTax: exchange/* ZERO_PERCENT */.fI,
        outputTax: exchange/* ZERO_PERCENT */.fI
    }), ref2 = ref1[0], inputTax = ref2.inputTax, outputTax = ref2.outputTax, setTaxes = ref1[1];
    (0,react.useEffect)(function() {
        if (!fotDetector || !chainId) {
            return;
        }
        getSwapTaxes(fotDetector, inputTokenAddress, outputTokenAddress, chainId).then(setTaxes);
    }, [
        fotDetector,
        inputTokenAddress,
        outputTokenAddress,
        chainId
    ]);
    return {
        inputTax: inputTax,
        outputTax: outputTax
    };
}

// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(19915);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(17937);
// EXTERNAL MODULE: ./src/utils/getBlocksFromTimestamps.ts
var getBlocksFromTimestamps = __webpack_require__(85003);
// EXTERNAL MODULE: ./src/utils/getChangeForPeriod.ts
var getChangeForPeriod = __webpack_require__(28839);
// EXTERNAL MODULE: ./src/utils/getDeltaTimestamps.ts
var getDeltaTimestamps = __webpack_require__(45802);
// EXTERNAL MODULE: ./src/utils/getLpAddress.ts
var utils_getLpAddress = __webpack_require__(80462);
// EXTERNAL MODULE: ./src/utils/getLpFeesAndApr.ts
var getLpFeesAndApr = __webpack_require__(67621);
// EXTERNAL MODULE: ./src/views/Swap/components/Chart/utils.ts + 1 modules
var Chart_utils = __webpack_require__(37930);
// EXTERNAL MODULE: ./src/state/index.ts + 22 modules
var state = __webpack_require__(46107);
// EXTERNAL MODULE: ./src/state/info/queries/pools/poolData.ts
var pools_poolData = __webpack_require__(72505);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(85588);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(7269);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js
var getUnixTime = __webpack_require__(99982);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfHour/index.js
var startOfHour = __webpack_require__(12383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js
var sub = __webpack_require__(30734);
// EXTERNAL MODULE: ./src/views/Info/utils/infoQueryHelpers.ts
var infoQueryHelpers = __webpack_require__(26604);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
;// CONCATENATED MODULE: ./src/state/swap/queries/getDerivedPrices.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query derivedTokenPriceData {\n        ",
        "\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getDerivedPrices = function(tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n    t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derivedBNB\n      }\n    ");
    });
};
var getDerivedPricesQueryConstructor = function(subqueries) {
    return (0,graphql_request_dist.gql)(_templateObject(), subqueries);
};

;// CONCATENATED MODULE: ./src/state/swap/types.ts
var types_PairDataTimeWindowEnum;
(function(PairDataTimeWindowEnum) {
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["DAY"] = 0] = "DAY";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["WEEK"] = 1] = "WEEK";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["MONTH"] = 2] = "MONTH";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["YEAR"] = 3] = "YEAR";
})(types_PairDataTimeWindowEnum || (types_PairDataTimeWindowEnum = {}));

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchDerivedPriceData.ts











var getTokenDerivedBnbPrices = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(tokenAddress, blocks) {
        var prices, tokenPrices;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,infoQueryHelpers/* multiQuery */.L)(getDerivedPricesQueryConstructor, getDerivedPrices(tokenAddress, blocks), endpoints/* INFO_CLIENT */.JY, 200)
                    ];
                case 1:
                    prices = _state.sent();
                    if (!prices) {
                        console.error("Price data failed to load");
                        return [
                            2,
                            null
                        ];
                    }
                    tokenPrices = [];
                    // Get Token prices in BNB
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                tokenAddress: tokenAddress,
                                timestamp: timestamp,
                                derivedBNB: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.derivedBNB) ? parseFloat(prices[priceKey].derivedBNB) : 0
                            });
                        }
                    });
                    return [
                        2,
                        orderBy_default()(tokenPrices, function(tokenPrice) {
                            return parseInt(tokenPrice.timestamp, 10);
                        })
                    ];
            }
        });
    });
    return function getTokenDerivedBnbPrices(tokenAddress, blocks) {
        return _ref.apply(this, arguments);
    };
}();
var getInterval = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return info/* ONE_HOUR_SECONDS */.Tb;
        case types_PairDataTimeWindowEnum.WEEK:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
        case types_PairDataTimeWindowEnum.MONTH:
            return info/* ONE_DAY_UNIX */.Bq;
        case types_PairDataTimeWindowEnum.YEAR:
            return info/* ONE_DAY_UNIX */.Bq * 15;
        default:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
    }
};
var getSkipDaysToStart = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return 1;
        case types_PairDataTimeWindowEnum.WEEK:
            return 7;
        case types_PairDataTimeWindowEnum.MONTH:
            return 30;
        case types_PairDataTimeWindowEnum.YEAR:
            return 365;
        default:
            return 7;
    }
};
// Fetches derivedBnb values for tokens to calculate derived price
// Used when no direct pool is available
var fetchDerivedPriceData_fetchDerivedPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(token0Address, token1Address, timeWindow) {
        var interval, endTimestamp, startTimestamp, timestamps, time, blocks, ref, token0DerivedBnb, token1DerivedBnb, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    interval = getInterval(timeWindow);
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    startTimestamp = (0,getUnixTime/* default */.Z)((0,startOfHour/* default */.Z)((0,sub/* default */.Z)(endTimestamp * 1000, {
                        days: getSkipDaysToStart(timeWindow)
                    })));
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0,getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestamps, "asc", 500)
                    ];
                case 2:
                    blocks = _state.sent();
                    if (!blocks || blocks.length === 0) {
                        console.error("Error fetching blocks for timestamps", timestamps);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            getTokenDerivedBnbPrices(token0Address, blocks),
                            getTokenDerivedBnbPrices(token1Address, blocks)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), token0DerivedBnb = ref[0], token1DerivedBnb = ref[1];
                    return [
                        2,
                        {
                            token0DerivedBnb: token0DerivedBnb,
                            token1DerivedBnb: token1DerivedBnb
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetched derived price data for chart", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDerivedPriceData(token0Address, token1Address, timeWindow) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchDerivedPriceData = ((/* unused pure expression or super */ null && (fetchDerivedPriceData_fetchDerivedPriceData)));

;// CONCATENATED MODULE: ./src/utils/requestWithTimeout.ts
var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ var utils_requestWithTimeout = (requestWithTimeout);

// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(61417);
;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairDayId.ts

function lastPairDayId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairDayId($pairId: String) {\n    pairDayDatas(first: 1, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairDayId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairDayId = (0,graphql_request_dist.gql)(lastPairDayId_templateObject());
/* harmony default export */ var queries_lastPairDayId = (lastPairDayId);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatas.ts

function pairHourDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatas($pairId: String, $first: Int) {\n    pairHourDatas(first: $first, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatas = (0,graphql_request_dist.gql)(pairHourDatas_templateObject());
/* harmony default export */ var queries_pairHourDatas = (pairHourDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatasByIdsQuery.ts

function pairDayDatasByIdsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatasByIdsQuery($pairIds: [String]) {\n    pairDayDatas(where: { id_in: $pairIds }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatasByIdsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatasByIdsQuery = (0,graphql_request_dist.gql)(pairDayDatasByIdsQuery_templateObject());
/* harmony default export */ var queries_pairDayDatasByIdsQuery = (pairDayDatasByIdsQuery);

;// CONCATENATED MODULE: ./src/state/swap/fetch/constants.ts


var _obj;
// Specifies the amount of data points to query for specific time window
var timeWindowIdsCountMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.DAY, 24), (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.WEEK, 28), (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.MONTH, 30), (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.YEAR, 24), _obj);
var _obj1;
// How many StreamingFast ids to skip when querying the data
var timeWindowGapMapping = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.DAY, null), (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.WEEK, 6), (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.MONTH, 1), (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.YEAR, 15), _obj1);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./src/state/swap/fetch/utils.ts



var getPairSequentialId = function(param) {
    var id = param.id, pairId = param.pairId;
    return id.replace("".concat(pairId, "-"), "");
};
var getIdsByTimeWindow = function(param) {
    var pairAddress = param.pairAddress, pairLastId = param.pairLastId, timeWindow = param.timeWindow, idsCount = param.idsCount;
    var pairLastIdAsNumber = Number(pairLastId);
    if (timeWindow === types_PairDataTimeWindowEnum.DAY) {
        return [];
    }
    return times_default()(idsCount, function(value) {
        return "".concat(pairAddress, "-").concat(pairLastIdAsNumber - value * timeWindowGapMapping[timeWindow]);
    });
};
var utils_pairHasEnoughLiquidity = function(data, timeWindow) {
    var liquidityThreshold = 10000;
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            {
                var ref, ref1;
                var ref2;
                var amountOfDataPoints = (ref2 = data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1;
                var totalUSD = data === null || data === void 0 ? void 0 : (ref1 = data.pairHourDatas) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD / amountOfDataPoints > liquidityThreshold;
            }
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            {
                var ref3, ref4;
                var ref5;
                var amountOfDataPoints1 = (ref5 = data === null || data === void 0 ? void 0 : (ref3 = data.pairDayDatas) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref5 !== void 0 ? ref5 : 1;
                var totalUSD1 = data === null || data === void 0 ? void 0 : (ref4 = data.pairDayDatas) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD1 / amountOfDataPoints1 > liquidityThreshold;
            }
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatas.ts

function pairDayDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatas($pairId: String, $first: Int) {\n    pairDayDatas(first: $first, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatas = (0,graphql_request_dist.gql)(pairDayDatas_templateObject());
/* harmony default export */ var queries_pairDayDatas = (pairDayDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatasByIds.ts

function pairHourDatasByIds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatasByIds($pairIds: [String]) {\n    pairHourDatas(where: { id_in: $pairIds }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatasByIds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatasByIds = (0,graphql_request_dist.gql)(pairHourDatasByIds_templateObject());
/* harmony default export */ var queries_pairHourDatasByIds = (pairHourDatasByIds);

;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairHourId.ts

function lastPairHourId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairHourId($pairId: String) {\n    pairHourDatas(first: 1, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairHourId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairHourId = (0,graphql_request_dist.gql)(lastPairHourId_templateObject());
/* harmony default export */ var queries_lastPairHourId = (lastPairHourId);

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchPairPriceData.ts













var fetchPairPriceData_fetchPairPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var pairId, timeWindow, client, data, ref, lastPairHourIdData, lastId, pairHourId, pairHourIds, pairHoursData, data1, ref1, lastPairDayIdData, lastId1, pairLastId, pairDayIds, pairDayData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pairId = param.pairId, timeWindow = param.timeWindow;
                    client = graphql/* infoClient */.dQ;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        14,
                        ,
                        15
                    ]);
                    switch(timeWindow){
                        case types_PairDataTimeWindowEnum.DAY:
                            return [
                                3,
                                2
                            ];
                        case types_PairDataTimeWindowEnum.WEEK:
                            return [
                                3,
                                4
                            ];
                        case types_PairDataTimeWindowEnum.MONTH:
                            return [
                                3,
                                7
                            ];
                        case types_PairDataTimeWindowEnum.YEAR:
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 3:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 4:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairHourId, {
                            pairId: pairId
                        })
                    ];
                case 5:
                    lastPairHourIdData = _state.sent();
                    lastId = (lastPairHourIdData === null || lastPairHourIdData === void 0 ? void 0 : lastPairHourIdData.pairHourDatas) ? (ref = lastPairHourIdData.pairHourDatas[0]) === null || ref === void 0 ? void 0 : ref.id : null;
                    if (!lastId) {
                        return [
                            2,
                            {
                                data: {
                                    pairHourDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairHourId = getPairSequentialId({
                        id: lastId,
                        pairId: pairId
                    });
                    pairHourIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairHourId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatasByIds, {
                            pairIds: pairHourIds
                        })
                    ];
                case 6:
                    pairHoursData = _state.sent();
                    return [
                        2,
                        {
                            data: pairHoursData,
                            error: false
                        }
                    ];
                case 7:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 8:
                    data1 = _state.sent();
                    return [
                        2,
                        {
                            data: data1,
                            error: false
                        }
                    ];
                case 9:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairDayId, {
                            pairId: pairId
                        })
                    ];
                case 10:
                    lastPairDayIdData = _state.sent();
                    lastId1 = (lastPairDayIdData === null || lastPairDayIdData === void 0 ? void 0 : lastPairDayIdData.pairDayDatas) ? (ref1 = lastPairDayIdData.pairDayDatas[0]) === null || ref1 === void 0 ? void 0 : ref1.id : null;
                    if (!lastId1) {
                        return [
                            2,
                            {
                                data: {
                                    pairDayDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairLastId = getPairSequentialId({
                        id: lastId1,
                        pairId: pairId
                    });
                    pairDayIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairLastId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatasByIdsQuery, {
                            pairIds: pairDayIds
                        })
                    ];
                case 11:
                    pairDayData = _state.sent();
                    return [
                        2,
                        {
                            data: pairDayData,
                            error: false
                        }
                    ];
                case 12:
                    return [
                        2,
                        {
                            data: null,
                            error: false
                        }
                    ];
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    error = _state.sent();
                    console.error("Failed to fetch price chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPairPriceData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchPairPriceData = ((/* unused pure expression or super */ null && (fetchPairPriceData_fetchPairPriceData)));

// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var lodash_fromPairs = __webpack_require__(17204);
;// CONCATENATED MODULE: ./src/state/swap/normalizers.ts



var normalizers_normalizeChartData = function(data, timeWindow) {
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            var ref;
            return data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.hourStartUnix,
                    token0Id: fetchPairEntry.pair.token0.id,
                    token1Id: fetchPairEntry.pair.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            var ref1;
            return data === null || data === void 0 ? void 0 : (ref1 = data.pairDayDatas) === null || ref1 === void 0 ? void 0 : ref1.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.date,
                    token0Id: fetchPairEntry.pairAddress.token0.id,
                    token1Id: fetchPairEntry.pairAddress.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        default:
            return null;
    }
};
var normalizers_normalizeDerivedChartData = function(data) {
    var ref;
    if (!(data === null || data === void 0 ? void 0 : data.token0DerivedBnb) || (data === null || data === void 0 ? void 0 : data.token0DerivedBnb.length) === 0) {
        return [];
    }
    var ref1;
    var token1DerivedBnbEntryMap = fromPairs((ref1 = data === null || data === void 0 ? void 0 : (ref = data.token1DerivedBnb) === null || ref === void 0 ? void 0 : ref.map(function(entry) {
        return [
            entry.timestamp,
            entry
        ];
    })) !== null && ref1 !== void 0 ? ref1 : []);
    return data === null || data === void 0 ? void 0 : data.token0DerivedBnb.reduce(function(acc, token0DerivedBnbEntry) {
        var token1DerivedBnbEntry = token1DerivedBnbEntryMap[token0DerivedBnbEntry.timestamp];
        if (token1DerivedBnbEntry) {
            acc.push({
                time: parseInt(token0DerivedBnbEntry.timestamp, 10),
                token0Id: token0DerivedBnbEntry.tokenAddress,
                token1Id: token1DerivedBnbEntry.tokenAddress,
                token0DerivedBNB: token0DerivedBnbEntry.derivedBNB,
                token1DerivedBNB: token1DerivedBnbEntry.derivedBNB
            });
        }
        return acc;
    }, []);
};
var normalizers_normalizePairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.reserve1 / pairPrice.reserve0 : pairPrice.reserve0 / pairPrice.reserve1
        };
    }).reverse();
};
var normalizers_normalizeDerivedPairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.token0DerivedBNB / pairPrice.token1DerivedBNB : pairPrice.token1DerivedBNB / pairPrice.token0DerivedBNB
        };
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__(27361);
;// CONCATENATED MODULE: ./src/state/swap/selectors.ts

var selectors_pairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "pairDataById",
            pairId,
            timeWindow
        ]);
    };
};
var selectors_derivedPairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "derivedPairDataById",
            pairId,
            timeWindow
        ]);
    };
};

;// CONCATENATED MODULE: ./src/state/swap/hooks.ts






































function useSwapState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.swap;
    });
}
// TODO: update
var BAD_RECIPIENT_ADDRESSES = [
    "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
    "0xf164fC0Ec4E93095b804a4795bBe1e041497b92a",
    "0x9695906B4502D5397E6D21ff222e2C1a9e5654a9"
];
/**
 * Returns true if any of the pairs or tokens in a trade have the given checksummed address
 * @param trade to check for the given address
 * @param checksummedAddress address to check in the pairs and tokens
 */ function involvesAddress(trade, checksummedAddress) {
    return trade.route.path.some(function(token) {
        return token.address === checksummedAddress;
    }) || trade.route.pairs.some(function(pair) {
        return pair.liquidityToken.address === checksummedAddress;
    });
}
// Get swap price for single token disregarding slippage and price impact
function useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency) {
    var ref;
    var token0Address = (0,Chart_utils/* getTokenAddress */.D)(inputCurrencyId);
    var token1Address = (0,Chart_utils/* getTokenAddress */.D)(outputCurrencyId);
    var parsedAmount = (0,tryParseAmount/* default */.Z)("1", inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(parsedAmount, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    if (!inputCurrency || !outputCurrency || !bestTradeExactIn) {
        return null;
    }
    var inputTokenPrice = parseFloat(bestTradeExactIn === null || bestTradeExactIn === void 0 ? void 0 : (ref = bestTradeExactIn.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var outputTokenPrice = 1 / inputTokenPrice;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, token0Address, inputTokenPrice), (0,_define_property/* default */.Z)(_obj, token1Address, outputTokenPrice), _obj;
}
// from the current swap inputs, compute the best trade and return it.
function useDerivedSwapInfo(independentField, typedValue, inputCurrency, outputCurrency, recipient) {
    var ref = (0,wagmi_src/* useWeb3React */.Ge)(), account = ref.account, chainId = ref.chainId;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1;
    var to = (ref1 = recipient === null ? account : (0,utils/* isAddress */.UJ)(recipient) || null) !== null && ref1 !== void 0 ? ref1 : null;
    var relevantTokenBalances = (0,wallet_hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var isExactIn = independentField === actions/* Field.INPUT */.gN.INPUT;
    var ref2;
    var parsedAmount = (0,tryParseAmount/* default */.Z)(typedValue, (ref2 = isExactIn ? inputCurrency : outputCurrency) !== null && ref2 !== void 0 ? ref2 : undefined);
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(isExactIn ? parsedAmount : undefined, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    var bestTradeExactOut = (0,Trades/* useTradeExactOut */["in"])(inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined, !isExactIn ? parsedAmount : undefined);
    var v2Trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    var ref3 = useSwapTaxes((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isToken) ? inputCurrency.address : undefined, (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.isToken) ? outputCurrency.address : undefined, chainId), inputTax = ref3.inputTax, outputTax = ref3.outputTax;
    var _obj;
    var currencyBalances = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, relevantTokenBalances[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, relevantTokenBalances[1]), _obj);
    var _obj1;
    var currencies = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,_define_property/* default */.Z)(_obj1, actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj1);
    var inputError;
    if (!account) {
        inputError = t("Connect Wallet");
    }
    if (!parsedAmount) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter an amount");
    }
    if (!currencies[actions/* Field.INPUT */.gN.INPUT] || !currencies[actions/* Field.OUTPUT */.gN.OUTPUT]) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Select a token");
    }
    var formattedTo = (0,utils/* isAddress */.UJ)(to);
    if (!to || !formattedTo) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter a recipient");
    } else if (BAD_RECIPIENT_ADDRESSES.indexOf(formattedTo) !== -1 || bestTradeExactIn && involvesAddress(bestTradeExactIn, formattedTo) || bestTradeExactOut && involvesAddress(bestTradeExactOut, formattedTo)) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Invalid recipient");
    }
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref4[0];
    var slippageAdjustedAmounts = v2Trade && allowedSlippage && (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(v2Trade, allowedSlippage);
    // compare input balance to max input based on version
    var ref5 = [
        currencyBalances[actions/* Field.INPUT */.gN.INPUT],
        slippageAdjustedAmounts ? slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT] : null, 
    ], balanceIn = ref5[0], amountIn = ref5[1];
    if (balanceIn && amountIn && balanceIn.lessThan(amountIn)) {
        inputError = t("Insufficient %symbol% balance", {
            symbol: amountIn.currency.symbol
        });
    }
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        parsedAmount: parsedAmount,
        v2Trade: v2Trade !== null && v2Trade !== void 0 ? v2Trade : undefined,
        inputError: inputError,
        inputTax: inputTax,
        outputTax: outputTax
    };
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "DOGE") return "DOGE";
        if (urlParam.toUpperCase() === "BONE") return "BONE";
        if (valid === false) return "BONE";
    }
    return "";
}
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? actions/* Field.OUTPUT */.gN.OUTPUT : actions/* Field.INPUT */.gN.INPUT;
}
var ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
function validatedRecipient(recipient) {
    if (typeof recipient !== "string") return null;
    var address = (0,utils/* isAddress */.UJ)(recipient);
    if (address) return address;
    if (ADDRESS_REGEX.test(recipient)) return recipient;
    return null;
}
function queryParametersToSwapState(parsedQs, nativeSymbol, defaultOutputCurrency) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || (nativeSymbol !== null && nativeSymbol !== void 0 ? nativeSymbol : exchange/* DEFAULT_INPUT_CURRENCY */.VN);
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || (defaultOutputCurrency !== null && defaultOutputCurrency !== void 0 ? defaultOutputCurrency : exchange/* DEFAULT_OUTPUT_CURRENCY */.g$);
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var recipient = validatedRecipient(parsedQs.recipient);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, {
        currencyId: inputCurrency
    }), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, {
        currencyId: outputCurrency
    }), (0,_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "recipient", recipient), (0,_define_property/* default */.Z)(_obj, "pairDataById", {}), (0,_define_property/* default */.Z)(_obj, "derivedPairDataById", {}), _obj;
}
// updates the swap state to use the defaults for a given network
function useDefaultsFromURLSearch() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var query = (0,router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!chainId || !native) return;
        var ref2;
        var parsed = queryParametersToSwapState(query, native.symbol, (ref2 = (ref = tokens_src/* CHEWY */.bY[chainId]) === null || ref === void 0 ? void 0 : ref.address) !== null && ref2 !== void 0 ? ref2 : (ref1 = tokens_src/* USDC */.gn[chainId]) === null || ref1 === void 0 ? void 0 : ref1.address);
        dispatch((0,actions/* replaceSwapState */.mV)({
            typedValue: parsed.typedValue,
            field: parsed.independentField,
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId,
            recipient: null
        }));
        setResult({
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query,
        native
    ]);
    return result;
}
var useFetchPairPrices = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, timeWindow = param.timeWindow, currentSwapPrice = param.currentSwapPrice;
    var ref = useState(null), pairId = ref[0], setPairId = ref[1];
    var ref1 = useState(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var pairData = useSelector(pairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var derivedPairData = useSelector(derivedPairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var dispatch = useDispatch();
    useEffect(function() {
        var fetchDerivedData = function() {
            var _ref = _async_to_generator(function() {
                var derivedData, normalizedDerivedData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.info("[Price Chart]: Not possible to retrieve price data from single pool, trying to fetch derived prices");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                fetchDerivedPriceData(token0Address, token1Address, timeWindow)
                            ];
                        case 2:
                            derivedData = _state.sent();
                            if (derivedData) {
                                normalizedDerivedData = normalizeDerivedChartData(derivedData);
                                dispatch(updateDerivedPairData({
                                    pairData: normalizedDerivedData,
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            } else {
                                dispatch(updateDerivedPairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Failed to fetch derived prices for chart", error);
                            dispatch(updateDerivedPairData({
                                pairData: [],
                                pairId: pairId,
                                timeWindow: timeWindow
                            }));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDerivedData() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchAndUpdatePairPrice = function() {
            var _ref = _async_to_generator(function() {
                var data, hasEnoughLiquidity, newPairData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            return [
                                4,
                                fetchPairPriceData({
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                hasEnoughLiquidity = pairHasEnoughLiquidity(data, timeWindow);
                                newPairData = normalizeChartData(data, timeWindow) || [];
                                if (newPairData.length > 0 && hasEnoughLiquidity) {
                                    dispatch(updatePairData({
                                        pairData: newPairData,
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    setIsLoading(false);
                                } else {
                                    console.info("[Price Chart]: Liquidity too low for ".concat(pairId));
                                    dispatch(updatePairData({
                                        pairData: [],
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    fetchDerivedData();
                                }
                            } else {
                                dispatch(updatePairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                                fetchDerivedData();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAndUpdatePairPrice() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!pairData && !derivedPairData && pairId && !isLoading) {
            fetchAndUpdatePairPrice();
        }
    }, [
        pairId,
        timeWindow,
        pairData,
        currentSwapPrice,
        token0Address,
        token1Address,
        derivedPairData,
        dispatch,
        isLoading, 
    ]);
    useEffect(function() {
        var updatePairId = function() {
            try {
                var ref;
                var pairAddress = (ref = getLpAddress(token0Address, token1Address)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                if (pairAddress !== pairId) {
                    setPairId(pairAddress);
                }
            } catch (error) {
                setPairId(null);
            }
        };
        updatePairId();
    }, [
        token0Address,
        token1Address,
        pairId
    ]);
    var normalizedPairData = useMemo(function() {
        return normalizePairDataByActiveToken({
            activeToken: token0Address,
            pairData: pairData
        });
    }, [
        token0Address,
        pairData
    ]);
    var normalizedDerivedPairData = useMemo(function() {
        return normalizeDerivedPairDataByActiveToken({
            activeToken: token0Address,
            pairData: derivedPairData
        });
    }, [
        token0Address,
        derivedPairData
    ]);
    var hasSwapPrice = currentSwapPrice && currentSwapPrice[token0Address] > 0;
    var normalizedPairDataWithCurrentSwapPrice = (normalizedPairData === null || normalizedPairData === void 0 ? void 0 : normalizedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedPairData;
    var normalizedDerivedPairDataWithCurrentSwapPrice = (normalizedDerivedPairData === null || normalizedDerivedPairData === void 0 ? void 0 : normalizedDerivedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedDerivedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedDerivedPairData;
    var hasNoDirectData = normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) === 0;
    var hasNoDerivedData = normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) === 0;
    // undefined is used for loading
    var pairPrices = hasNoDirectData && hasNoDerivedData ? [] : undefined;
    if (normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedPairDataWithCurrentSwapPrice;
    } else if (normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedDerivedPairDataWithCurrentSwapPrice;
    }
    return {
        pairPrices: pairPrices,
        pairId: pairId
    };
};
var useLPApr = function(pair) {
    var ref = (0,dist/* default */.Z)(pair && pair.chainId === swap_sdk_src/* ChainId.SHIBARIUM */.a_.SHIBARIUM ? [
        "LP7dApr",
        pair.liquidityToken.address
    ] : null, /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var timestampsArray, blocks, ref, block24h, block48h, block7d, block14d, ref1, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, current, oneDay, twoDays, week, twoWeeks, ref2, volumeUSD, ref3, volumeUSDWeek, liquidityUSD, lpApr7d;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timestampsArray = (0,getDeltaTimestamps/* getDeltaTimestamps */.z)();
                    return [
                        4,
                        (0,getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestampsArray, "desc", 1000)
                    ];
                case 1:
                    blocks = _state.sent();
                    ref = (0,_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref[0], block48h = ref[1], block7d = ref[2], block14d = ref[3];
                    return [
                        4,
                        (0,pools_poolData/* fetchPoolData */.jf)(block24h.number, block48h.number, block7d.number, block14d.number, [
                            pair.liquidityToken.address.toLowerCase()
                        ])
                    ];
                case 2:
                    ref1 = _state.sent(), error = ref1.error, data = ref1.data;
                    if (error) return [
                        2,
                        null
                    ];
                    formattedPoolData = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.now);
                    formattedPoolData24h = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    formattedPoolData48h = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    formattedPoolData7d = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    formattedPoolData14d = (0,pools_poolData/* parsePoolData */.l4)(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    current = formattedPoolData[pair.liquidityToken.address.toLowerCase()];
                    oneDay = formattedPoolData24h[pair.liquidityToken.address.toLowerCase()];
                    twoDays = formattedPoolData48h[pair.liquidityToken.address.toLowerCase()];
                    week = formattedPoolData7d[pair.liquidityToken.address.toLowerCase()];
                    twoWeeks = formattedPoolData14d[pair.liquidityToken.address.toLowerCase()];
                    ref2 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 1), volumeUSD = ref2[0];
                    ref3 = (0,_sliced_to_array/* default */.Z)((0,getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 1), volumeUSDWeek = ref3[0];
                    liquidityUSD = current ? current.reserveUSD : 0;
                    lpApr7d = (0,getLpFeesAndApr/* getLpFeesAndApr */.z)(volumeUSD, volumeUSDWeek, liquidityUSD).lpApr7d;
                    return [
                        2,
                        lpApr7d ? {
                            lpApr7d: lpApr7d
                        } : null
                    ];
            }
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), poolData = ref.data;
    return poolData;
};


/***/ })

}]);